<template>
  <div
    class="dot-divider"
    :style="{ fontSize, color, margin }"
  >
    <q-icon
      size="8px"
      name="fiber_manual_record"
    ></q-icon>
  </div>
</template>

<script>
export default {
  props: {
    fontSize: {
      type: String,
      default: '6px',
    },
    color: {
      type: String,
      default: 'grey',
    },
    margin: {
      type: String,
      default: '0 3px',
    },
  },
};
</script>
